/**
 * @generated by @interxfi/j5-codegen (Plugin: NormalizedQueryPlugin) - do not edit */

import type { IxmUserauthV1ProgramState } from '@interxfi/types';
import { schema } from 'normalizr';

export const IXM_USERAUTH_V1_PROGRAM_STATE_ENTITY_NAME = 'ixm.userauth.v1.Program';
export const ixmUserauthV1ProgramStateEntity = new schema.Entity<IxmUserauthV1ProgramState>(IXM_USERAUTH_V1_PROGRAM_STATE_ENTITY_NAME, {}, { idAttribute: 'programId' });

